<template>
  <v-container
    fluid
    class="nl-theme-background"
  >
    <v-row>
      <v-col
        cols="2"
        align-self="end"
      >
        OpenVOXEL Project 2017-2020
      </v-col>
      <v-col
        cols="2"
        offset="1"
        class="link-column"
      >
        <div class="subtitle-1 text-uppercase">
          The Project
        </div>
        <OpenvoxelAboutDialog />
        <OpenvoxelContactDialog />
      </v-col>
      <v-col
        cols="2"
        class="link-column"
      >
        <div class="subtitle-1 text-uppercase">
          Partner With Us
        </div>
        <OpenvoxelScientistsDialog />
        <OpenvoxelImagingCentersDialog />
      </v-col>
      <v-col
        cols="2"
        class="link-column"
      >
        <div class="subtitle-1 text-uppercase">
          Legal
        </div>
        <OpenvoxelTermsDialog />
        <OpenvoxelDataProtectionDialog />
      </v-col>
      <v-col
        class="text-right"
        cols="2"
        offset="1"
        align-self="end"
      >
        <v-btn
          text
          icon
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OpenvoxelAboutDialog from '@/layout/BottomDrawer/openvoxelDialogs/OpenvoxelAboutDialog.vue';
import OpenvoxelContactDialog from '@/layout/BottomDrawer/openvoxelDialogs/OpenvoxelContactDialog.vue';
import OpenvoxelDataProtectionDialog from '@/layout/BottomDrawer/openvoxelDialogs/OpenvoxelDataProtectionDialog.vue';
import OpenvoxelImagingCentersDialog from '@/layout/BottomDrawer/openvoxelDialogs/OpenvoxelImagingCentersDialog.vue';
import OpenvoxelScientistsDialog from '@/layout/BottomDrawer/openvoxelDialogs/OpenvoxelScientistsDialog.vue';
import OpenvoxelTermsDialog from '@/layout/BottomDrawer/openvoxelDialogs/OpenvoxelTermsDialog.vue';

export default {
  name: 'OpenvoxelBottomDrawer',
  components: {
    OpenvoxelAboutDialog,
    OpenvoxelContactDialog,
    OpenvoxelDataProtectionDialog,
    OpenvoxelImagingCentersDialog,
    OpenvoxelScientistsDialog,
    OpenvoxelTermsDialog,
  },
};
</script>

<style lang="scss" scoped>
.link-column > * {
  display: block !important;
}

>>> a {
  text-decoration: none;
}
</style>
